<template>
  <v-container fluid>
    <LibrosConab v-if="$store.state.emp.cod_empresa == 383" />
    <LibrosSwisstex v-if="$store.state.emp.cod_empresa == 381" />
    <LibrosUnique v-if="$store.state.emp.cod_empresa == 380" />
    <LibrosPersonalSoft v-if="$store.state.emp.cod_empresa == 398" />
    <LibrosIBMaker v-if="$store.state.emp.cod_empresa == 469" />
    <LibrosHygge v-if="$store.state.emp.cod_empresa == 460" />
    <LibrosNaka v-if="$store.state.emp.cod_empresa == 466" />
    <LibrosPanacom v-if="$store.state.emp.cod_empresa == 414" />
    <LibrosTxool v-if="$store.state.emp.cod_empresa == 445" />
    <LibrosJadip v-if="$store.state.emp.cod_empresa == 493" />
    <AbelLibros v-if="$store.state.emp.cod_empresa == 476" />
    <Pruebalibros v-if="$store.state.emp.cod_empresa == 313" />
    <Consultorialibros v-if="$store.state.emp.cod_empresa == 475" />
    <LibrosAna v-if="$store.state.emp.cod_empresa == 477" />
    <LibrosGomez v-if="$store.state.emp.cod_empresa == 601" />
    <LibrosLibreria v-if="$store.state.emp.cod_empresa == 600" />
    <LibrosWalter v-if="$store.state.emp.cod_empresa == 474" />
    <LibrosSuc v-if="$store.state.emp.cod_empresa == 494" />
    <LibrosCarlos v-if="$store.state.emp.cod_empresa == 483" />
    <LibrosWilliam v-if="$store.state.emp.cod_empresa == 48" />
    <LibrosBilly v-if="$store.state.emp.cod_empresa == 473" />

  </v-container>
</template>

<script>
import LibrosConab from './Conab/ConabIVA.vue';
import LibrosSwisstex from './Swisstex/SwisstexIVA.vue';
import LibrosUnique from './Uniquee/IVAU.vue';
import LibrosPersonalSoft from './PersonalSoft/PersonalSoftIVA.vue';
import LibrosIBMaker from './IBMaker/IBMlibros.vue';
import LibrosHygge from './Hygge/LibrosHygge.vue';
import LibrosNaka from './Naka/Nakalibros.vue';
import LibrosPanacom from './Panacom/Panacomlibros.vue';
import LibrosTxool from './Txool/Txoollibros.vue';
import LibrosJadip from './Jadip/Jadiplibros.vue';
import AbelLibros from './Abel/AbelLibros.vue';
import Pruebalibros from './Pruebalibros.vue';
import Consultorialibros from './Consultoria/Consultorialibros.vue';
import LibrosAna from './Ana/AnaIVA.vue';
import LibrosGomez from './DrGomez/LibrosGomez.vue';
import LibrosLibreria from './Libreria/Librerialibros.vue';
import LibrosWalter from './Walter/LibrosWalter.vue';
import LibrosSuc from './SUC/LibrosSuc.vue';
import LibrosCarlos from './CarlosNieto/CarlosIVA.vue';
import LibrosWilliam from './William/WilliamIVA.vue';
import LibrosBilly from './Billy/BillyIVA.vue';

export default {
  data: () => ({
    //
  }),
  components: {
    LibrosConab,
    LibrosSwisstex,
    LibrosUnique,
    LibrosPersonalSoft,
    LibrosIBMaker,
    LibrosHygge,
    LibrosNaka,
    LibrosPanacom,
    LibrosTxool,
    LibrosJadip,
    AbelLibros,
    Pruebalibros,
    Consultorialibros,
    LibrosAna,
    LibrosGomez,
    LibrosLibreria,
    LibrosWalter,
    LibrosSuc,
    LibrosCarlos,
    LibrosWilliam,
    LibrosBilly
  },
};
</script>